import { useEffect, useRef } from 'react';
import { playSoundEffect } from '../hooks/useSoundEffects';

/**
 * Play counterstrike.mp3 the moment the opponent strike-back overlay appears
 * (when opponentHasCounterStrike rises false → true).
 */
export function useCounterStrikeSound(opponentHasCounterStrike, gameId) {
  const prevShowRef = useRef(false);
  const gameIdRef = useRef(null);

  useEffect(() => {
    if (gameIdRef.current !== gameId) {
      gameIdRef.current = gameId;
      prevShowRef.current = false;
    }

    const wasShowing = prevShowRef.current;
    const isShowing = opponentHasCounterStrike === true;

    if (isShowing && !wasShowing) {
      playSoundEffect('/sounds/counterstrike.mp3', 0.7);
    }

    prevShowRef.current = isShowing;
  }, [opponentHasCounterStrike, gameId]);
}

export default useCounterStrikeSound;
